import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useUserStore } from '@/store/userStore';
import { ROUTES } from '@/routes';
import type { UserRole } from '@/constants';

interface RequireRoleProps {
  roles: UserRole[];
  children?: React.ReactNode;
}

export const RequireRole: React.FC<RequireRoleProps> = ({ roles, children }) => {
  const { user } = useUserStore();

  if (!user || !roles.includes(user.role)) {
    return <Navigate to={ROUTES.SESSIONS} replace />;
  }

  return children ? <>{children}</> : <Outlet />;
};

export default RequireRole;
